import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { ConfigurationService } from '../../../configuration/configuration-service';
import { TranslatePipe } from '../../../translate/translate.pipe';
import { Documentale } from '../../models/documentale';
import { DocumentoDTO } from '../../models/documento-dto';
import { StatoDocumentoDTO } from '../../models/stato-documento-dto';
import { saveAs } from "file-saver";

@Component({
	selector: 'lib-visualizza-dettagli',
	templateUrl: './visualizza-dettagli.component.html',
	styleUrls: ['./visualizza-dettagli.component.css']
})
export class VisualizzaDettagliComponent implements OnInit {

	@Input()
	documentoSelezionato: Documentale;

	dettagli: string;
	data: string;
	numeroRighe: string
	dataJson: any;
	documentaleServiceUrl: string;

	constructor(
		private traduzione: TranslatePipe,
		private http: HttpClient,
		private configurationService: ConfigurationService) { }

	ngOnInit(): void {
		console.log('[Documentale]', this.documentoSelezionato)
		this.documentaleServiceUrl = this.configurationService.servicePaths.get('DOCUMENTALE_MS_API_URL');
		
		this.dettagli = this.traduzione.transform('visualizzaDettagli');
		try {
			this.dataJson = JSON.parse(this.documentoSelezionato.jsonMetadati);
		}
		catch (e) {
			this.dataJson = null;
			console.log('[error occored while you were typing the JSON]');
		};
		// this.data = this.pagamento.dataValuta != null ?
		//   moment(new Date(this.pagamento.dataValuta)).format("DD/MM/YYYY") : '';
		// this.contaRighe();
	}

	accordionOpened() {
		this.dettagli = this.traduzione.transform('nascondiDettagli');
	}
	accordionClosed() {
		this.dettagli = this.traduzione.transform('visualizzaDettagli');
	}

	contaRighe() {
		// if (this.pagamento.motivoScarto) {
		// 	let par = this.pagamento.motivoScarto;
		// 	par = par.replace(/(^\s*)|(\s*$)/gi, "");
		// 	par = par.replace(/[ ]{2,}/gi, " ");
		// 	par = par.replace(/\n /, "\n");
		// 	let numeroRighe = par.split('').length / 180;
		// 	this.numeroRighe = Math.ceil(numeroRighe).toString()
		// }
	}

	downloadFile(documento: DocumentoDTO) {
		const url: string = this.documentaleServiceUrl + documento.url;
		console.log('[url]', url);
		const headers = new HttpHeaders();
		headers.append('Accept', 'text/plain');
		this.http.get(url, { headers: headers, responseType: 'blob' }).subscribe(response => this.saveFile(response, documento.nome))
	}

	isValid(stato: Array<StatoDocumentoDTO>) {
		if (stato.filter(s => s.lastState == true)) {
			return true;
		} else {
			return false;
		}
	}

	saveFile(response, nomeFile) {
		const blob = new Blob([response], { type: 'text/plain' });
		saveAs(blob, nomeFile);
	}

}